import { FC, useEffect } from 'react';
import styled from '@emotion/styled';
import LiftUpReport from '../component/compound/LiftUpReport/LiftUpReport';
import IndexReport from '../component/compound/IndexReport/IndexReport';
import { Organization } from '@kaizenplatform/intelligence-entity';
import GlobalPeriod from '../../entity/GlobalPeriod';
import { IChart as LiftReportChart } from '../../entity/Chart';
import Loading from '../component/compound/Loading';
import LiftReportToolBar from '../connected/LiftReportToolBar';
import { PageContainer, PageHeader, PageTitle } from '../component/primitive/Page';
import { PaperItem, StyledPaper } from '../component/primitive/Paper';

type Props = {
  organization: Organization | null;
  liftReportLiftUp?: LiftReportChart;
  liftReportIndex?: LiftReportChart;
  liftReportCoverage?: LiftReportChart;
  goalId: string | null;
  liftReportChartSetting: GlobalPeriod;
  liftReportLoading: boolean;
  onMount: () => void;
  onUnmount: () => void;
  className?: string;
};

const LiftReportPage: FC<Props> = ({
  organization,
  liftReportLiftUp,
  liftReportIndex,
  liftReportCoverage,
  goalId,
  liftReportChartSetting,
  liftReportLoading,
  onMount,
  onUnmount,
  className,
}) => {
  useEffect(() => {
    if (organization) {
      onMount();
    }

    return () => {
      onUnmount();
    };
  }, [organization]);

  return (
    <Root className={className}>
      <PageContainer>
        <LiftReportToolBar />
        <PageHeader>
          <PageTitle>施策効果レポート</PageTitle>
        </PageHeader>
        {liftReportLoading ? (
          <StyledPaper>
            <PaperItem>
              <LoadingContainer>
                <Loading />
              </LoadingContainer>
            </PaperItem>
          </StyledPaper>
        ) : (
          <LiftUpReport
            liftReport={liftReportLiftUp}
            goalId={goalId}
            liftReportChartSetting={liftReportChartSetting}
            liftReportLoading={liftReportLoading}
          />
        )}
        {liftReportLoading ? (
          <StyledPaper>
            <LoadingContainer>
              <Loading />
            </LoadingContainer>
          </StyledPaper>
        ) : (
          <IndexReport
            liftReportIndex={liftReportIndex}
            liftReportCoverage={liftReportCoverage}
            goalId={goalId}
            liftReportChartSetting={liftReportChartSetting}
            liftReportLoading={liftReportLoading}
          />
        )}
      </PageContainer>
    </Root>
  );
};

const Root = styled('div')({});

const LoadingContainer = styled('div')({
  height: '600px',
});

export default LiftReportPage;
